import React, { PureComponent } from 'react'
import { reduxForm } from 'redux-form'
import { Col, Table, Tooltip, OverlayTrigger, Button } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import SignatureConfigModalPage from '../../../containers/masters/SignatureConfig/SignatureConfigModalPage'
import MapSectionsMasters from '../../../util/map-sections-masters'

class SignatureConfig extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: null
    }
  }

  componentDidMount () {
    this.props.actions.fetchSignTypeCombo()
    this.props.actions.fetchSignEntityTypeCombo()
    this.props.actions.fetchSignatureConfigList()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchSignatureConfigList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchSignatureConfigList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  render () {
    const {
      t,
      signatureConfigList,
      pagesCount, signatureConfigCount, filter,
      filter: { page },
      actions: {
        openEditSignatureConfigModal,
        deleteSignatureConfig
      }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'signatureConfigurationMasterPage' })
    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)

    return (
      <div id='SignatureConfigMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openEditSignatureConfigModal()}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">

            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(signatureConfigCount !== 0) &&
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('documentTypeUse') }}>
                      {t(`${tKey}SIGNATURE_CONFIG_MASTERS.DOCUMENT_TYPE_USE`)}
                      <i className={this.getSortIcon('documentTypeUse')} />
                    </th>
                    <th onClick={() => { this.changeOrder('code') }}>
                      {t(`${tKey}SIGNATURE_CONFIG_MASTERS.CONFIG_CODE`)}
                      <i className={this.getSortIcon('code')} />
                    </th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {signatureConfigList && signatureConfigList.map((signatureConfig, idx) => (
                    <tr key={idx}>
                      <td>{signatureConfig.documentTypeUse}</td>
                      <td>{signatureConfig.code}</td>
                      <td className='actions'>
                        <div>
                          <OverlayTrigger placement="left" overlay={editTooltip}>
                            <a className='_Btn accept stk o-icn ' onClick={() => openEditSignatureConfigModal(signatureConfig)}>
                              <i className="iDocIcon-edit" />
                            </a>
                          </OverlayTrigger>
                          <OverlayTrigger placement="left" overlay={deleteTooltip}>
                            <a className='_Btn cancel stk o-icn ' onClick={() => deleteSignatureConfig(signatureConfig.signDocumentConfigurationId)}>
                              <i className="iDocIcon-delete-forever" />
                            </a>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))
                  }

                </tbody>
              </Table>
              }
              {(signatureConfigList === null || signatureConfigList === undefined || signatureConfigList.length === 0) &&
                <p className="no_results">{t(`${tKey}SIGNATURE_CONFIG_MASTERS.RESULTS_NOT_FOUND`)}</p>
              }
            </div>
          </div>
        </div>

        <Col sm={12} className="col-row  section-users-body">

          <div className="section-users-footer">
            <nav key={1} className="text-center">
              <IDocCarPagination
                id="btn_pag_sales"
                page={page}
                pagesCount={pagesCount}
                totalRows={signatureConfigCount}
                onSelectAction={(value) =>
                  this.props.actions.fetchSignatureConfigList({ ...filter, ...this.state.filter, page: value })
                }
              />
            </nav>
          </div>
        </Col>
        <SignatureConfigModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listSignatureConfig'
})(SignatureConfig)
